/**
 * @author: wayou
 * @date: 2018-08-28 12:12:54
 * @description: 简单的Toast
 */

import './index.scss';

export interface IToastOptions {
    style?: string;
    class?: string;
    message: string | number;
    duration?: number;
    animationDuration?: number | string;
    callback?: () => void;
}

export class Toast {
    /**
     * 展示Toast
     *
     * @static
     * @param {string} message 需要展示的消息文本
     * @memberof Toast
     */
    public static show(message: string): void;
    /**
     * 展示Toast，自定义展示的表现
     *
     * @static
     * @param {IToastOptions} options Toast参数
     * @memberof Toast
     */
    public static show(options: IToastOptions): void;
    public static show(options: string | IToastOptions) {
        let toastOption: IToastOptions = Object.assign({}, this.defaultOptions, options);
        if (typeof options === 'string') {
            toastOption = Object.assign({}, this.defaultOptions, {
                message: options,
            });
        } else {
            toastOption = Object.assign({}, this.defaultOptions, options);
        }
        let element = document.getElementById(`clipboard-toast`);
        if (this.timer) {
            window.clearTimeout(this.timer);
            this.timer = null;
            this._hide(element);
        }
        if (!element) {
            element = this.create(toastOption);
        } else {
            this.applyOption(element, toastOption);
        }

        this._show(element);
        this.timer = window.setTimeout(() => {
            this._hide(element);
            if (typeof options === 'string') {
                return;
            }
            if (options.callback) {
                options.callback();
            }
        }, toastOption.duration);
    }

    public static hide() {
        const element = document.getElementById(`clipboard-toast`);
        if (!element) {
            return;
        }
        if (this.timer) {
            window.clearTimeout(this.timer);
            this.timer = null;
        }
        this._hide(element);
    }

    private static defaultOptions: IToastOptions = {
        duration: 3000,
        message: '',
        class: '',
        style: '',
        animationDuration: '0.5s',
    };

    private static timer: number | null = null;

    /**
     * 每次展示时重新运用Toast参数，因为每次展示时不同调用地方可传递不同参数
     * 但Toast全局只有一个
     * @param element Toast根节点
     * @param toastOption Toast参数
     */
    private static applyOption(element: HTMLElement, toastOption: IToastOptions) {
        element.className = `${toastOption.class}`;
        // tslint:disable-next-line:max-line-length
        element.style.cssText = `${toastOption.style};transition: visibility 0s, opacity ${toastOption.animationDuration} linear;`;
        element.innerHTML = (
            `
            ${toastOption.message}
            ` || ''
        ).trim();
    }

    /**
     * 创建Toast元素
     * @param toastOption Toast参数
     */
    private static create(toastOption: IToastOptions): HTMLElement {
        const element = document.createElement('div');
        element.setAttribute('id', 'clipboard-toast');
        this.applyOption(element, toastOption);
        document.body.appendChild(element);
        return element;
    }

    /**
     * 设置 `show` className 以展示Toast
     * @param element Toast根节点
     */
    private static _show(element: HTMLElement | null) {
        if (element) {
            element.className += ' show';
        }
    }

    /**
     * 移除 `show` clasName 以隐藏Toast
     * @param element Toast根节点
     */
    private static _hide(element: HTMLElement | null) {
        if (element) {
            element.className = element.className.replace('show', '');
        }
    }
}
